import { DEFAULT_LOCALE, isLocaleCode } from '@instanexus/contracts';
/** `en-GB` -> `en`; anything not in LOCALES -> null. */
function toLocaleCode(tag) {
    if (typeof tag !== 'string')
        return null;
    const base = tag.trim().toLowerCase().split('-')[0] ?? '';
    return isLocaleCode(base) ? base : null;
}
/** `fr-CA,fr;q=0.9,en;q=0.8` -> the supported locales, best quality first. */
function parseAcceptLanguage(header) {
    const weighted = [];
    for (const part of header.split(',')) {
        const segments = part.split(';');
        const tag = (segments[0] ?? '').trim();
        if (tag.length === 0)
            continue;
        const qualityParam = segments
            .slice(1)
            .map((segment) => segment.trim())
            .find((segment) => segment.startsWith('q='));
        const parsed = qualityParam === undefined ? 1 : Number.parseFloat(qualityParam.slice(2));
        const quality = Number.isFinite(parsed) ? parsed : 0;
        if (quality <= 0)
            continue;
        weighted.push({ tag, quality });
    }
    // Array.prototype.sort is stable, so equal-quality tags keep header order.
    return weighted
        .sort((a, b) => b.quality - a.quality)
        .map((entry) => toLocaleCode(entry.tag))
        .filter((locale) => locale !== null);
}
/**
 * Resolution order (docs/011-i18n.md):
 * 1. explicit user preference, 2. tenant default, 3. `Accept-Language`, 4. `en`.
 * Unsupported values at any step fall through to the next step rather than failing.
 */
export function resolveLocale(options = {}) {
    const fromUser = toLocaleCode(options.userPreference);
    if (fromUser !== null)
        return fromUser;
    const fromTenant = toLocaleCode(options.tenantDefault);
    if (fromTenant !== null)
        return fromTenant;
    const header = options.acceptLanguage;
    if (typeof header === 'string' && header.trim().length > 0) {
        const fromHeader = parseAcceptLanguage(header)[0];
        if (fromHeader !== undefined)
            return fromHeader;
    }
    return DEFAULT_LOCALE;
}
//# sourceMappingURL=resolve-locale.js.map